// React component for homepage/market page banner strip
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {fetchMarketCommentary} from "../../api";
import TypingHeadline from "../ui/typing";

const MarketCommentaryBanner = () => {
  const [title, setTitle] = useState('');
  const [headline, setHeadline] = useState('');
  const [fullHtml, setFullHtml] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchLatestCommentary = async () => {
      try {
        const res = await fetchMarketCommentary();
        console.log("MARKET COMMENTARY AT FETCH",res)
        const { title,headline, content } = res;
        setTitle(title);
        setHeadline("-"+title + " : " +headline);
        setFullHtml(content);
      } catch (error) {
        console.error('Failed to fetch commentary:', error);
      }
    };

    fetchLatestCommentary();
  }, []);

  if (!headline) return null;

  const styles = {
    banner: {
      position: 'sticky',
      top: 0,
      zIndex: 50,
      width: '100%',
      backgroundColor: '#FEF3C7',
      borderBottom: '1px solid #FCD34D',
      padding: '0.5rem 1rem',
      fontSize: '0.875rem',
      color: '#92400E',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    readMoreButton: {
      marginLeft: '1rem',
      color: '#2563EB',
      textDecoration: 'underline',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      fontSize: 'inherit',
    },
    overlay: {
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 50,
    },
    modal: {
      backgroundColor: '#ffffff',
      borderRadius: '0.5rem',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      maxWidth: '768px',
      width: '100%',
      maxHeight: '80vh',
      overflowY: 'auto',
      padding: '1.5rem',
      position: 'relative',
    },
    closeButton: {
      position: 'absolute',
      top: '0.5rem',
      right: '-20rem',
      color: '#6B7280',
      background: 'none',
      border: 'none',
      fontSize: '1.25rem',
      cursor: 'pointer',
    },
  };

  return (
    <div style={styles.banner}>
{/*<span*/}
{/*  style={{*/}
{/*    overflow: 'hidden',*/}
{/*    textOverflow: 'ellipsis',*/}
{/*    whiteSpace: 'nowrap',*/}
{/*    fontWeight: '600',*/}
{/*    fontSize: '1.25rem',*/}
{/*    letterSpacing: '0.3px',*/}
{/*    color: '#92400E',*/}
{/*    fontFamily: 'Segoe UI, Roboto, sans-serif',*/}
{/*    animation: 'fadeInPulse 2s ease-in-out',*/}
{/*  }}*/}
{/*>*/}
{/*  📰 <em>{title} -- {headline}</em>*/}
{/*</span>*/}

{/*<style>*/}
{/*  {`*/}
{/*    @keyframes fadeInPulse {*/}
{/*      0% { opacity: 0; transform: scale(0.98); }*/}
{/*      50% { opacity: 1; transform: scale(1.02); }*/}
{/*      100% { transform: scale(1); }*/}
{/*    }*/}
{/*  `}*/}
{/*</style>*/}
      <TypingHeadline text={headline} speed={50} delay={20000} />

      <button onClick={() => setIsOpen(true)} style={styles.readMoreButton}>
        Read More
      </button>

      {isOpen && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <button onClick={() => setIsOpen(false)} style={styles.closeButton} aria-label="Close">
            <div>❌</div>
            </button>
    <span
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontWeight: '800',
        fontSize: '2rem',
        paddingBottom:'30px',
        letterSpacing: '0.3px',
        color: '#92400E',
        fontFamily: 'Segoe UI, Roboto, sans-serif',
      }}
    >
      {title}
    </span>
          <div style={{ textAlign: 'left' }}>
            <div dangerouslySetInnerHTML={{ __html: fullHtml }} />
          </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarketCommentaryBanner;
